<h3 class="title">{{title}}</h3>

<app-alert class="mb-2 alert-component" [icon]="'alert'" [textWidth]="'511px'">
  <span [innerHTML]="message"></span>
</app-alert>

<img [src]="image" class="schedule-image" width="246" height="238" alt="">

<span *ngIf="linksList.length">
  <h3 class="title">{{linksTitle}}</h3>

  <div class="links">
    <a *ngFor="let link of linksList" [href]="link.url" target="_blank">{{link.name}}</a>
  </div>
</span>